import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { ROUTE_PATHS } from '@/lib/index';
import { Layout } from '@/components/Layout';
import Overview from '@/pages/Overview';
import PipelinePage from '@/pages/Pipeline';
import CodebookPage from '@/pages/Codebook';
import CISPLogPage from '@/pages/CISPLog';

function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[40vh] text-center">
      <span className="font-mono text-xs text-muted-foreground uppercase tracking-widest mb-2">
        404 · Route not found
      </span>
      <h1 className="text-2xl font-bold text-foreground">Page Not Found</h1>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path={ROUTE_PATHS.HOME} element={<Overview />} />
          <Route path={ROUTE_PATHS.PIPELINE} element={<PipelinePage />} />
          <Route path={ROUTE_PATHS.CODEBOOK} element={<CodebookPage />} />
          <Route path={ROUTE_PATHS.CISP_LOG} element={<CISPLogPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
  );
}
